export default __webpack_public_path__ + "static/media/img_step_hami04.a5bf16be.png";